/**
 * @generated SignedSource<<0f3829651e0da1bc2849f4ca766ca016>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum ConfluencePolicyEnabledStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  UNDETERMINED_DUE_TO_INTERNAL_ERROR = "UNDETERMINED_DUE_TO_INTERNAL_ERROR",
}
export type useDataRetentionDetailsGetDetailsQuery_confluence_dataLifecycleManagementPolicy_ConfluenceDataLifecycleManagementPolicy_dataRetentionPolicyDetailsForWorkspace_ConfluenceDataRetentionPolicyStatus_disabledOnDate_Date =
  {
    __typename?: "Date";
    value: string;
  };
export type useDataRetentionDetailsGetDetailsQuery_confluence_dataLifecycleManagementPolicy_ConfluenceDataLifecycleManagementPolicy_dataRetentionPolicyDetailsForWorkspace_ConfluenceDataRetentionPolicyStatus =
  {
    __typename?: "ConfluenceDataRetentionPolicyStatus";
    policyEnabledStatus: ConfluencePolicyEnabledStatus;
    disabledOnDate: useDataRetentionDetailsGetDetailsQuery_confluence_dataLifecycleManagementPolicy_ConfluenceDataLifecycleManagementPolicy_dataRetentionPolicyDetailsForWorkspace_ConfluenceDataRetentionPolicyStatus_disabledOnDate_Date | null;
  };
export type useDataRetentionDetailsGetDetailsQuery_confluence_dataLifecycleManagementPolicy_ConfluenceDataLifecycleManagementPolicy =
  {
    __typename?: "ConfluenceDataLifecycleManagementPolicy";
    dataRetentionPolicyDetailsForWorkspace: useDataRetentionDetailsGetDetailsQuery_confluence_dataLifecycleManagementPolicy_ConfluenceDataLifecycleManagementPolicy_dataRetentionPolicyDetailsForWorkspace_ConfluenceDataRetentionPolicyStatus;
  };
export type useDataRetentionDetailsGetDetailsQuery_Query = {
  __typename?: "Query";
  confluence_dataLifecycleManagementPolicy: useDataRetentionDetailsGetDetailsQuery_confluence_dataLifecycleManagementPolicy_ConfluenceDataLifecycleManagementPolicy | null;
};
export type useDataRetentionDetailsGetDetailsQueryVariables = Exact<{
  cloudId: Scalars["ID"]["input"];
}>;
export type useDataRetentionDetailsGetDetailsQuery =
  useDataRetentionDetailsGetDetailsQuery_Query;
